import { render, staticRenderFns } from "./ActivitySchedule.vue?vue&type=template&id=5b335452"
import script from "./ActivitySchedule.vue?vue&type=script&lang=js"
export * from "./ActivitySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports